import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const TermsAndConditions = () => {
    return (
        <div className="h-auto flex flex-col bg-[#F7F7F7] ">
            <div className="sticky top-0 z-50">
                <Navbar />
            </div>
            <div className="w-full lg:px-[7%] px-[2%] py-12 flex flex-col lg:gap-12 gap-8">
                <span className="lg:text-2xl text-xl font-[600] font-display underline">Terms & Conditions</span>
                <p className="text-sm lg:text-base font-display text-gray-700 leading-relaxed">
                    At ALIK STORE, we aim to provide the best shopping experience for our customers. These Terms and
                    Conditions outline the rules and guidelines for using our website and services.
                </p>

                <h2 className="text-xl lg:text-2xl font-semibold">Acceptance of Terms</h2>
                <p>
                    By accessing and using our website, you agree to these Terms and Conditions. If you do not agree with
                    any part of these terms, please do not use our website.
                </p>

                <h2 className="text-xl lg:text-2xl font-semibold">Products and Orders</h2>
                <p>
                    All prices listed on our website are in the relevant currency and inclusive of applicable taxes. We
                    reserve the right to change prices at any time without prior notice. Payment must be made at the time of
                    purchase using the available payment methods.
                </p>

                <h2 className="text-xl lg:text-2xl font-semibold">Pricing and Payment</h2>
                <p>
                    All prices listed on our website are in the relevant currency and inclusive of applicable taxes. We
                    reserve the right to change prices at any time without prior notice. Payment must be made at the time of
                    purchase using the available payment methods.
                </p>

                <h2 className="text-xl lg:text-2xl font-semibold">Shipping and Delivery</h2>
                <p>
                    We strive to process and ship your orders promptly. Delivery times may vary based on location and
                    shipping method. Please review our Shipping Policy for more details.
                </p>

                <h2 className="text-xl lg:text-2xl font-semibold">Returns and Refunds</h2>
                <p>
                    We accept returns and issue refunds in accordance with our Returns Policy. Please review this policy for
                    specific information on eligibility and procedures.
                </p>

                <h2 className="text-xl lg:text-2xl font-semibold">Intellectual Property</h2>
                <p>
                    All content on our website, including text, images, logos, and graphics, is the property of ALIK STORE
                    and is protected by intellectual property laws. You may not use, reproduce, or distribute any content
                    without our prior written consent.
                </p>
                <h2 className="text-xl lg:text-2xl font-semibold">Limitation of Liability</h2>
                <p>
                    To the fullest extent permitted by law, ALIK STORE shall not be liable for any indirect, incidental, or
                    consequential damages arising from your use of our website or services.
                </p>
                <h2 className="text-xl lg:text-2xl font-semibold">Changes to Terms and Conditions</h2>
                <p>
                    We reserve the right to update or modify these Terms and Conditions at any time. Changes will be
                    reflected on this page, and we encourage you to review these terms periodically.
                </p>
                <h2 className="text-xl lg:text-2xl font-semibold">Contact Us</h2>
                <p>
                    If you have any questions or concerns about these Terms and Conditions, please contact us at
                    alikstore.ind@gmail.com.
                </p>

                <p className="text-sm lg:text-base font-display text-gray-700 leading-relaxed">
                    Last updated: [00/MAR/2025]
                </p>
            </div>
            <div className="mt-7">
                <Footer />
            </div>
        </div>
    );
};

export default TermsAndConditions;
